const configData = {
	accountStateData: [
		{ value: 1, label: '启用' },
		{ value: 2, label: '禁用' }
	],
	downloadOrderData: [
		{ value: 'auto', label: '自动下载订单' },
		{ value: 'manual', label: '手动下载订单' }
	],
	updateDepotData: [
		{ value: 'auto', label: '自动更新' },
		{ value: 'manual', label: '手动更新' }
	],
	autoShipData: [
		{ value: 'auto', label: '自动发货' },
		{ value: 'manual', label: '手动发货' }
	],
	autoConfigStrategyData: [
		{ value: 'none', label: '不设置' },
		{ value: 'fixedPriceChannel', label: '一口价选渠道-通用规则' },
		{ value: 'safetyStockPrice', label: '通用安全库存规则改价格' }
	],
	autoConfigStockSyncData: [
		{ value: 'enabled', label: '自动配置商品更新库存' },
		{ value: 'disabled', label: '不配置' }
	],
	autoConfigOrderData: [
		{ value: 'enabled', label: '自动配置商品自动下单' },
		{ value: 'disabled', label: '不配置' }
	],
	autoDownloadAftersaleData: [
		{ value: 'enabled', label: '启用' },
		{ value: 'disabled', label: '停用' }
	],
	autoApplyAftersaleMandatoryData: [
		{ value: 'autoApply', label: '自动申请' },
		{ value: 'noAutoApply', label: '不自动申请' }
	],
	returnTrackingFeedbackData: [
		{ value: 'feedback', label: '反馈' },
		{ value: 'noFeedback', label: '不反馈' }
	],
	aftersaleTypesNoFeedbackData: [
		{ value: 'returnRefund', label: '退货退款' },
		{ value: 'exchange', label: '换货' },
		{ value: 'onlyRefund', label: '仅退款' }
	],
	aftersaleAutoRefund: [
		{ value: 'manual', label: '手动确认' },
		{ value: 'auto', label: '自动确认' }
	],
	autoCancelAftersale: [
		{ value: 'autoCancel', label: '自动取消' },
		{ value: 'noAutoCancel', label: '不自动取消' }
	],
	orderFlagColorData: [
		{ value: 'none', label: '不处理', color: '' },
		{ value: 'clear', label: '清除', color: '#dcdfe6' },
		{ value: 'green', label: '绿色', color: '#67c23a' },
		{ value: 'red', label: '红色', color: '#f56c6c' },
		{ value: 'yellow', label: '黄色', color: '#e6a23c' },
		{ value: 'blue', label: '蓝色', color: '#409eff' },
		{ value: 'purple', label: '紫色', color: '#9b59b6' }
	],
	skuOuterIdRuleData: [
		{ value: 'system_default', label: '平台默认（竖杠）：AWDT871-1|8 → 款号 AWDT871-1、尺码 8' },
		{ value: '|', label: '竖杠：AWDT871-1|8 → 款号 AWDT871-1、尺码 8' },
		{ value: '/', label: '斜杠：AWDT871-1/8 → 款号 AWDT871-1、尺码 8' },
		{ value: '-', label: '减号（拆最后一段）：AWDT871-1-8 → 款号 AWDT871-1、尺码 8' },
		{ value: 'none', label: '无分隔符：AWDT871-18 → 反向剥离' }
	]
}

export default configData



// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/configObj.js